export default function IconBathUltimate() {
	return (
		<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" id="Bathroom-Tub-Towel--Streamline-Ultimate" height="100%" width="100%">
			<desc>{'\n    Bathroom Tub Towel Streamline Icon: https://streamlinehq.com\n  '}</desc>
			<path
				d="M13.5 14.274h9.486a0.5 0.5 0 0 1 0.5 0.53 9 9 0 0 1 -8.985 8.47h-5A9 9 0 0 1 0.515 14.8a0.5 0.5 0 0 1 0.5 -0.53H6.5"
				fill="none"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth={1}
			/>
			<path
				d="m17.27 2.136 0.9 -0.9a2 2 0 0 1 3.329 1.5v11.538"
				fill="none"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth={1}
			/>
			<path
				d="M17.27 5.488a2.37 2.37 0 1 0 -3.351 -3.352l-0.205 0.205a0.5 0.5 0 0 0 0 0.707l2.644 2.645a0.5 0.5 0 0 0 0.708 0Z"
				fill="none"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth={1}
			/>
			<path d="m11.408 3.356 -1.816 0.837" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} />
			<path d="m15.893 7.855 -0.786 1.839" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} />
			<path d="m13.211 6.071 -1.422 1.407" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} />
			<path
				d="M13.5 13.274a1 1 0 0 0 -1 -1h-5a1 1 0 0 0 -1 1v5.5a0.5 0.5 0 0 0 0.5 0.5h6a0.5 0.5 0 0 0 0.5 -0.5Z"
				fill="none"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth={1}
			/>
		</svg>
	);
}
